// @flow
import { entityReducer } from "src/utils/reducerUtils";
import RiskModel from "src/models/RiskModel";

export const locationRisks = entityReducer({
  name: "locationRisks",
  Model: RiskModel
});
